<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject">step 4 | Qty</div>

    <b-row class="stencilform-price-box mt-4">
      <div class="col-sm-8">Price per Character:</div>
      <div class="col-sm-4 stencilform-price-box-lineitem">$ <strong>{{letterPrice}}</strong></div>
    </b-row>

    <b-table :items="lineItems"></b-table>

    <b-row class="stencilform-price-box" v-if="lineItems.length > 0">
      <div class="col-sm-6">Total Price:</div>
      <div class="col-sm-6 stencilform-price-box-lineitem">$ <strong>{{totalPrice}}</strong></div>
    </b-row>

    <b-button variant="default" class="mt-4 go-next go-add-to-cart" v-on:click="add_to_cart" v-if="lineItems.length > 0">Add to cart</b-button>
    <b-button variant="default" class="mt-4 go-next go-add-to-cart" disabled v-else>Add to cart</b-button>
  </div>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios';
import { STENCILCONST } from '../modules/constant.js.erb'

export default {
  data() {
    return {
      stencileaseQty: '1',
      products: __se_products_json
    }
  },
  computed: {
    letterPrice: function() {
      let variant = this.getVariant()
      return variant.price
    },
    totalPrice: function() {
      let total_qtys = 0
      let items_org = this.$store.state.product.items
      items_org.forEach(function(item, index){
        total_qtys += parseInt(item)
      })

      let total_price = total_qtys * this.letterPrice
      return total_price.toFixed(2)
    },
    lineItems: function() {
      let items = []
      let items_org = this.$store.state.product.items
      items_org.forEach(function(item, index){
        items.push({
          character: STENCILCONST._letters[index],
          qty: item
        })
      })
      return items
    }
  },
  methods: {
    formatMoney(v, c, d, t){
      var n = v,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    },
    getVariant() {
      let material = this.$store.state.product.material

      let products = []
      for(let i in this.products) {
        if(this.products[i].title.search(material) != -1) {
          products.push(this.products[i])
        }
      }

      const matching_height_text = `Height ${this.$store.state.product.textHeight} inches`;

      let variant = null
      for(let i in products) {
        for(let j in products[i].variants) {
          if(products[i].variants[j].option1 == matching_height_text) {
            variant = products[i].variants[j]
          }
        }
      }

      return variant
    },
    add_to_cart() {
      let variant = this.getVariant()
      if (variant != null) {
        let items = []
        let qty = 0
        let items_org = this.$store.state.product.items
        items_org.forEach(function(item, index){
          items.push(STENCILCONST._letters[index] + ': ' + item)
          qty += parseInt(item)
        })

        let textFont = this.$store.state.product.textFont

        let params = {
          "id": variant.id,
          "quantity": qty,
          "properties": {
            "Font": textFont,
            "Characters": items.join(", ")
          }
        }

        axios.post('/cart/add.js', params)
          .then(response => {
            location.href = '/cart';
          })
          .catch(e => console.log(e))
      }
    }
  }
}
</script>
